import React from "react";
import { useOutletContext } from "react-router-dom";
import MyJourney from "./components/Journey/MyJourney";
import LearnerContentFrame from "./components/LearnerContentFrame";

const MyJourneyPage = () => {
  const { layoutPhase } = useOutletContext();

  return (
    <LearnerContentFrame layoutPhase={layoutPhase}>
      <MyJourney />
    </LearnerContentFrame>
  );
};

export default MyJourneyPage;
